import { createContext } from 'react'
import { TToastsContext } from './types'

export default createContext<TToastsContext>(null)
